import React, { useEffect, useState } from 'react';
import Navigation from '../components/Navigation';
import { NavLink } from 'react-router-dom';
import base_url from '../config/Config';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import Spinner from 'react-bootstrap/Spinner';
import { FaEyeSlash, FaDownload, FaTrashAlt } from 'react-icons/fa';
import PageLoader from '../components/PageLoader';

const AllCustomer = () => {

    const [customer, setCustomer] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [isDownloading, setIsDownloading] = useState(false);
    const [searchOption, setSearchOption] = useState('');
    const [searchInput, setSearchInput] = useState('');
    const [pageLoading, setPageLoading] = useState(true);

    const customersPerPage = 50;

    useEffect(() => {
        getAllCustomer();
    }, []);

    const getAllCustomer = () => {
        axios.get(`${base_url}/api1/customer/excelCustomerList`).then(
            (response) => {
                setCustomer(response.data.reverse());
            },
            (error) => {
                console.log(error);
            }
        ).finally(() => setPageLoading(false));
    };

    const handleExportAllCustomer = async () => {
        setIsDownloading(true);
        try {
            const response = await axios.get(`${base_url}/api1/customer/customerToExport`, {
                responseType: 'blob'
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'all_customer_data.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            alert('Export Customer Data successfully');
        } catch (error) {
            console.error('Error generating export:', error.response?.data || error.message);
            alert('Export Customer Data failed');
        } finally {
            setIsDownloading(false);
        }
    };


     // Handle customer delete
     const handleDeleteCustomer = async (id) => {
        if (window.confirm('Are you sure you want to delete this customer?')) {
            let config = {
                method: 'delete',
                maxBodyLength: Infinity,
                url: `${base_url}/api1/customer/deleteInCustomerLoanCVerified?id=${id}`,
                headers: { }
            };

            try {
                const response = await axios.request(config);
                console.log(JSON.stringify(response.data));
                alert('Customer deleted successfully');
                // Refresh customer list after deletion
                getAllCustomer();
            } catch (error) {
                console.error('Error deleting customer:', error);
                alert('Failed to delete customer');
            }
        }
    };

    // search filter API 
    const handleSearch = (event) => {
        event.preventDefault();
        if (searchOption && searchInput) {
            let url = '';
            switch (searchOption) {
                case 'borrower_name':
                    url = `${base_url}/api1/customer/searchByBorrowerName?borrowerName=${searchInput}`;
                    break;
                case 'borrower_id':
                    url = `${base_url}/api1/customer/searchByBorrowerId?borrowerId=${searchInput}`;
                    break;
                case 'phone':
                    url = `${base_url}/api1/customer/searchByMobileNumber?mobileNumber=${searchInput}`;
                    break;
                default:
                    break;
            }
            axios.get(url).then(
                (response) => {
                    console.log(response.data);
                    setCustomer(response.data);
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    };

    // search filter API end 

    const indexOfLastCustomer = currentPage * customersPerPage;
    const indexOfFirstCustomer = indexOfLastCustomer - customersPerPage;
    const Customers = customer.slice(indexOfFirstCustomer, indexOfLastCustomer);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const totalPages = Math.ceil(customer.length / customersPerPage);

    const maxPageButtons = 10;

    const getPaginationRange = () => {
        const midPoint = Math.ceil(maxPageButtons / 2);
        let startPage = currentPage - midPoint + 1;
        let endPage = startPage + maxPageButtons - 1;

        if (startPage <= 0) {
            startPage = 1;
            endPage = Math.min(totalPages, maxPageButtons);
        } else if (endPage > totalPages) {
            endPage = totalPages;
            startPage = Math.max(1, endPage - maxPageButtons + 1);
        }

        return { startPage, endPage };
    };

    const { startPage, endPage } = getPaginationRange();

    return (
        <>
            <div className='overviewsaa'>
                <h4>Customer Details</h4>
            </div>
            <div className='navigationss mb-5'>
                <Navigation />
            </div>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-2 col-md-2 sidebarnavigartion'>
                        <div className='lmssidebar'>
                            <Sidebar />
                        </div>
                    </div>
                    <div className='col-lg-10 col-md-10'>
                        <div className='dashboardlms mt-5 text-center'>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='searchtoll'>
                                        <form onSubmit={handleSearch}>
                                            <div className='row'>
                                                <div className="col-md-3 col-3">
                                                    <div className=" required">
                                                        <select name="option" id="option" className="form-control" value={searchOption}  onChange={(e) => setSearchOption(e.target.value)} required="required">
                                                            <option value="" selected="selected">Search By</option>
                                                            <option value="borrower_name">Borrower Name</option>
                                                            <option value="borrower_id">Partner Id</option>
                                                            <option value="phone">Phone</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-5 col-6">
                                                    <div className=" required">
                                                        <input type="text" className="form-control" placeholder="Search..." value={searchInput} onChange={(e) => setSearchInput(e.target.value)} required/>
                                                    </div>
                                                </div>
                                                
                                                <div className="col-md-2 col-3">
                                                    <button type="submit" className="btn btn-sm btn-primary">Search</button>
                                                </div>
                                                
                                                <div className="col-md-2 mt-2">
                                                    <div className="export">
                                                        <NavLink to="#" className="exportbutton" onClick={handleExportAllCustomer}>
                                                            {isDownloading ? (
                                                                <Spinner animation="border" size="sm" />
                                                            ) : (
                                                                <>
                                                                Export  <FaDownload />
                                                                </>
                                                            )}
                                                        </NavLink>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div className='col-md-12 col-lg-12 '>
                                    <div className='allcustomer table-responsive mb-5 mt-3'>
                                        {pageLoading ? (
                                            <PageLoader text="Loading customer list..." />
                                        ) : Customers.length > 0 ? (
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th>S.No.</th>
                                                        <th>Employee_Id</th>
                                                        <th>Borrower_Name</th>
                                                        <th>Mobile_Number</th>
                                                        <th>Accrued_Salary</th>
                                                        <th>Account_Number</th>
                                                        <th>Date_Of_Birth </th>
                                                        <th>Status</th>
                                                        <th>View</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {Customers.map((data, index) => (
                                                        <tr key={index}>
                                                            <td>{data.id}</td>
                                                            <td>{data.empId}</td>
                                                            <td>{data.borrowerName}</td>
                                                            <td>{data.mobileNumber}</td>
                                                            <td>{data.salary}</td>
                                                            <td>{data.aadharNumber}</td>
                                                            <td>{data.dob}</td>
                                                            <td>{data.status}</td>
                                                            <td className='iconss'>
                                                                <NavLink to={`/operation/ViewCustomer?id=${encodeURIComponent(data.id)}`}> <FaEyeSlash /></NavLink>
                                                            </td>
                                                            <td><button
                                                                    className="btn btn-danger btn-sm ml-2"
                                                                    onClick={() => handleDeleteCustomer(data.id)}
                                                                >
                                                                    <FaTrashAlt />
                                                                </button></td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        ) : (
                                            <p className="empty-state">No customers found.</p>
                                        )}
                                    </div>
                                    <div className='pagination mb-5'>
                                        {startPage > 1 && (
                                            <>
                                                <button onClick={() => paginate(1)}>1</button>
                                                <span>...</span>
                                            </>
                                        )}
                                        {Array.from({ length: endPage - startPage + 1 }, (_, i) => (
                                            <button
                                                key={startPage + i}
                                                onClick={() => paginate(startPage + i)}
                                                className={currentPage === startPage + i ? 'active' : ''}
                                            >
                                                {startPage + i}
                                            </button>
                                        ))}
                                        {endPage < totalPages && (
                                            <>
                                                <span>...</span>
                                                <button onClick={() => paginate(totalPages)}>{totalPages}</button>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AllCustomer;
